<template>
  <div>
    <div class="table_responsive">
      <table class="table">
        <thead>
        <tr>
          <th>Ticket ID</th>
          <th>Subject</th>
          <th>Priority</th>
          <th>Request From</th>
          <th>Status</th>
          <th>Created At</th>
        </tr>
        </thead>
        <tbody>
        <template v-if="tickets.length > 0">
          <tr v-for="ticket in tickets" :key="ticket.id">
            <td>
              <router-link :to="`ticket/${ticket.ticket_number}`" class="text-underline">{{
                  ticket.ticket_number
                }}
              </router-link>
            </td>
            <td>{{ ticket.subject }}</td>
            <td>{{ ticket.priority }}</td>
            <td>{{ ticket.request_from }}</td>
            <td>
              <div class="form_input">
                <select class="form_global" v-model="ticket.status" @change="ticketStatusUpdate(ticket.id, ticket.status)">
                  <option v-for="status in statuses" :key="status.label" :value="status.label">
                    {{ status.name }}
                  </option>
                </select>
              </div>
            </td>
            <td>{{ ticket.formatted_created_at }}</td>
          </tr>
        </template>
        <template v-else>
          <td colspan="5" class="text_center">No tickets found!</td>
        </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "CloseTicketList",
  props: ['selectedCustomer', 'loadData'],
  data() {
    return {
      tickets: [],
      statuses: [
        {
          label: 'open',
          name: 'Open'
        },
        {
          label: 'pending',
          name: 'Pending'
        },
        {
          label: 'resolved',
          name: 'Resolved'
        },
        {
          label: 'closed',
          name: 'Closed'
        },

      ],
    }
  },
  mounted() {
    this.getTicketList();
  },
  methods: {
    getTicketList() {
      this.axios.get(`/customer-chat-support-ticket/${this.selectedCustomer.id}`)
          .then(({data}) => {
            this.tickets = data.data
          })
    },
    ticketStatusUpdate(ticketID, status) {
      this.axios.post(`/update-chat-support-ticket/${this.selectedCustomer.id}/${ticketID}`, {
        status: status
      })
          .then(({data}) => {
            if (data.success) {
              this.showSuccessMsg("Ticket status updated Successfully!");
              this.loadData('no');
            } else {
              this.showFailMsg(data.message);
            }
          })
    },
  }
}
</script>
<style scoped>

</style>